class CareerModel {
	id;

	title;

	jobDescription;

	primaryResponsabilities;

	requirements;

	personalAttributes;

	additionalBeneficialExperience;

	thePosition;

	constructor({
		_id = '',
		title = '',
		jobDescription = '',
		primaryResponsabilities = '',
		requirements = '',
		personalAttributes = '',
		additionalBeneficialExperience = '',
		thePosition = '',
	}) {
		this.id = _id;
		this.title = title;
		this.jobDescription = jobDescription;
		this.primaryResponsabilities = primaryResponsabilities;
		this.requirements = requirements;
		this.personalAttributes = personalAttributes;
		this.additionalBeneficialExperience = additionalBeneficialExperience;
		this.thePosition = thePosition;
	}
}

export default CareerModel;
